const BounceLeftIcon = /*#__PURE__*/ [
  ["path", { d: "M9 10C11.1153 13.01 12.1055 17.1528 12.752 20.086C12.8835 20.6824 12.9492 20.9806 13.0872 20.9991C13.2252 21.0177 13.3662 20.7339 13.6482 20.1662C14.9939 17.4579 17.7827 15.062 20 17.1079", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "2", cy: "2", r: "2", transform: "matrix(-1 0 0 1 8 3)", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export { BounceLeftIcon as default };
//# sourceMappingURL=BounceLeftIcon.js.map
